<template>
  <div class="w-half text-white mapbox relative bg-cover bg-center bg-no-repeat flex items-center justify-end" :class="mapRotate" :style="mapStyle">
    <visualize-control v-if="hasOSCCommand" :cue="osc"></visualize-control>
    <map-slider v-if="hasMultipleMaps" @map-slider-changed="cb" :maps="maps" ref="slider"></map-slider>
  </div>
</template>
<script>
import VisualizeControl from './VisualizeControl'
import MapSlider from './MapSlider'

export default {
  name: 'map-sidebar',
  props: ['maps', 'osc'],
  components: {
    'visualize-control': VisualizeControl,
    'map-slider': MapSlider
  },

  data () {
    return {
      activeMap: null,
      fallbackMaps: {
        north: '@/assets/images/map-placeholder.png',
        south: '@/assets/images/map-placeholder-south.png'
      }
    }
  },

  activated () {
    this.setActiveDefault()
  },

  deactivated () {
    this.activeMap = null
  },

  mounted () {
    this.setActiveDefault()
  },

  methods: {
    cb (val) {
      this.maps.forEach((item) => {
        if (item.label === val) {
          this.activeMap = item
        }
      })
    },

    setActiveDefault () {
      if (this.maps) {
        if (this.maps !== null && this.maps.length > 0) {
          this.activeMap = this.maps[this.maps.length - 1]
        }
      }
    }
  },

  watch: {
    currentUri (val) {
      this.setActiveDefault()
    }
  },

  computed: {

    currentUri () {
      return this.$route.path
    },

    hasOSCCommand () {
      return (this.osc)
    },

    location () {
      return this.$store.getters['settings/location']
    },

    hasMultipleMaps () {
      return (this.maps && this.maps.length > 1)
    },

    mapRotate () {
      return 'mapbox_' + this.location
    },

    mapStyle () {
      let str = ''
      if (this.hasMapBackground) {
        str = 'background: url(' + this.mapbackgroundUrl + ') center center / cover no-repeat;'
      }
      return str
    },

    hasMapBackground () {
      if (this.maps) {
        if (this.maps !== null && this.maps.length > 0 && this.activeMap !== null) return true
      }
      return false
    },

    mapbackgroundUrl () {
      let map = this.activeMap

      if (map !== null) return map[this.location]
      return this.fallbackMaps[this.location]
    }
  }
}
</script>